import React, { useEffect, useState } from "react";
import BillCommentsView from "./Comments/Comments";
import axios from "axios";
import { Card, CardContent, Divider } from "@material-ui/core";
import { useFlags } from "../../../../../config/featureFlags";

const getComments = async (documentIds) => {
  return axios.post(
    "/api/proposals/documents",
    { documentIds: documentIds, teamId: null },
    {
      withCredentials: true,
    }
  );
};

const createComments = async (documentId, uuid, billText, text) => {
  const teamId = localStorage.getItem("teamId");

  const refNodeJson = {
    type: "paragraph",
    attrs: {
      "data-uuid": documentId[0],
    },
    content: [
      {
        type: "text",
        text: billText,
      },
    ],
  };

  return axios.post(
    "/api/proposals",
    {
      uuid: uuid,
      refNodeJson: JSON.stringify(refNodeJson),
      documentId: documentId[0],
      teamId: parseInt(teamId),
      content: text,
    },
    {
      withCredentials: true,
    }
  );
};

const BillShowCode = ({
  doc,
  documentId,
  topDocument,
  voteBtn,
  billHasPassedDeadline,
}) => {
  const prefix_ = '<p data-uuid="';
  const split = doc?.content?.split(prefix_)?.slice(1);

  // const {comments} = useContext(CommentsContext)
  // useEffect(() => console.log('myfunc',comments), [comments])

  const [comments, setComments] = useState([]);

  useEffect(() => {
    getComments(documentId).then(
      (res) => res?.data?.length && setComments(res?.data)
    );
  }, []);

  const refreshComments = () => {
    getComments(documentId).then(
      (res) => res?.data?.length && setComments(res?.data)
    );
  };

  const callbackTextarea = async (text, uuid, billText) => {
    const res = await createComments(documentId, uuid, billText, text);
    refreshComments();

    return !!res?.data?.id;
  };

  return (
    <>
      {topDocument?.content && (
        <Card>
          <CardContent>
            <div dangerouslySetInnerHTML={{ __html: topDocument?.content }} />
            {voteBtn}
          </CardContent>
        </Card>
      )}
      {doc?.billId !== 34 ? (
        split.map((one, key) => {
          const uuid = one.split('"')[0];
          const billText = `${prefix_}${one}`;

          const commentsInBill = comments.filter(
            (comment) => comment.uuid === uuid
          );

          return (
            <Card style={{ marginTop: 25 }}>
              <CardContent>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      doc?.descriptions && doc.descriptions[key]
                        ? doc?.descriptions[key]?.description
                        : billText,
                  }}
                />

                {commentsInBill && (
                  <>
                    <Divider component="li" />

                    <BillCommentsView
                      comments={commentsInBill}
                      refreshComments={refreshComments}
                      callbackTextarea={callbackTextarea}
                      uuid={uuid}
                      billText={billText}
                      billHasPassedDeadline={billHasPassedDeadline}
                    />
                  </>
                )}
              </CardContent>
            </Card>
          );
        })
      ) : (
        <Card style={{ marginTop: 25 }}>
          <CardContent>
            {split.map((one, key) => {
              const billText = `${prefix_}${one}`;
              return (
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      doc?.descriptions && doc.descriptions[key]
                        ? doc?.descriptions[key]?.description
                        : billText,
                  }}
                />
              );
            })}
          </CardContent>
        </Card>
      )}
      {!topDocument?.content && voteBtn}
    </>
  );
};

export default BillShowCode;
